import React from 'react'
import { connect } from 'react-redux'
import styles from './Body.module.css';
import { PatientHomeCdvDoc, PatientHomeCdvPocDoc, PatientHomeCdvLimberDoc, PatientHomeCdvAl } from 'PatientCareCenter/Home/Cdv'
import { patientActions } from '_actions';
import { bindActionCreators } from 'redux';
import { CancelButton, SaveButton } from '_components';

class PatientHomeCdvBody extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSupervisorDDL: false,
            selectedSupervisorId: '',
            activeRowId: null,
            dropdownOptions: {}
        };
    }

    componentDidMount() {
        // Load limber assessments on initial mount if needed
        if (this.props.limberAssessments.length === 0 && this.props.limberActive && this.props.fotoVisible) {
            this.limberLoaded = true;
            this.props.loadLimber(this.props.epno);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { supervisors } = this.props.supervisorOptions;
        const { activeRowId, dropdownOptions } = this.state;

        if (Array.isArray(supervisors) && supervisors !== prevProps.supervisorOptions.supervisors) {
            // Only update the state if the options for the active row have changed
            if (activeRowId && (dropdownOptions[activeRowId] !== supervisors)) {
                this.setState((prevState) => ({
                    dropdownOptions: {

                        ...prevState.dropdownOptions,
                        [activeRowId]: supervisors,
                    },
                    selectedSupervisorId: this.props.docs.find(x => x.id === activeRowId).thnoSupv === undefined ? this.props.docs.find(x => x.id === activeRowId).thnosupv : this.props.docs.find(x => x.id === activeRowId).thnoSupv,
                }));
            }
        }
    }

    handleChange = (docId, event) => {
        const selectedSupervisorId = event.target.value;

        if (selectedSupervisorId) {
            const selectedSupervisor = this.state.dropdownOptions[docId]?.find(
                supervisor => supervisor.THNO == selectedSupervisorId
            );

            if (selectedSupervisor) {
                this.setState({
                    selectedSupervisorId: selectedSupervisor.THNO,
                });

            }
        }
    };

    updateSupervisor = (docId, epno) => {

        const { selectedSupervisorId } = this.state;

        const selectedSupervisor = this.state.dropdownOptions[docId]?.find(
            supervisor => supervisor.THNO == selectedSupervisorId
        );


        // Update the dropdownOptions state with the selected supervisor


        if (selectedSupervisor) {
            const updatedDoc = {
                ...this.props.docs[docId],
                therapist: selectedSupervisor,
            };
            const noteType = parseInt(updatedDoc.therapist.NoteId.split("_")[0]);
            if (noteType === 1) {
                this.props.updateSupervisior(updatedDoc.therapist.EVNO, noteType, selectedSupervisorId, epno, this.props.ptno);
            } else {
                this.props.updateSupervisior(updatedDoc.therapist.NTNO, noteType, selectedSupervisorId, epno, this.props.ptno);
            }
            this.hideSupervisors();
        }
    };


    showSupervisors = (doc) => {
        if (!this.state.dropdownOptions[doc.id]) {
            const supervisorOptions = this.props.loadSupervisiors(parseInt(doc.id.split("_")[1]), doc.noteType, doc.epno);

            this.setState({
                showSupervisorDDL: true,
                activeRowId: doc.id,
                dropdownOptions: {
                    ...this.state.dropdownOptions,
                    [doc.id]: supervisorOptions,
                },
            });
        }
    };

    hideSupervisors = (doc) => {
        this.setState({
            showSupervisorDDL: false,
            selectedSupervisorId: '',
            activeRowId: null,
            dropdownOptions: {}
        });
    };

    render() {
        if (this.props.visible) {
            if (Object.keys(this.props.docs).length === 0 && Object.keys(this.props.limberAssessments).length === 0) {
                return (
                    <div className={styles.no_docs}><i>No documentation</i></div>
                )
            } else {
                return (

                    <div className={styles.body_wrapper}>
                        <PatientHomeCdvAl id={this.props.id} />

                        {this.props.fotoVisible && Object.keys(this.props.limberAssessments)
                            .map(id => {
                                const doc = this.props.limberAssessments[id];
                                return (
                                    <div id={doc.assessmentId} key={doc.assessmentId}>
                                        <PatientHomeCdvLimberDoc key={doc.assessmentId} id={doc.assessmentId} />
                                    </div>
                                )
                            })
                        }


                        {Object.keys(this.props.docs)
                            .map(id => {
                                const doc = this.props.docs[id];
                                return (
                                    <div id={doc.id} key={doc.id}>
                                        <PatientHomeCdvDoc key={doc.id} id={doc.id} showSupervisors={(doc) => this.showSupervisors(doc)} />
                                        {this.state.showSupervisorDDL && doc.status === 3 && (doc.noteType === 1 || doc.noteType === 2 || doc.noteType === 3 || doc.noteType === 4 || doc.noteType === 5 || doc.noteType === 6
                                            || doc.noteType === 22)
                                            &&
                                            <div className={styles.row}>
                                                <span className={styles.body_left_col1}>Supervising Therapist:</span>
                                                <span className={styles.body_left_col2}>

                                                    {this.state.showSupervisorDDL && this.state.activeRowId === doc.id && (
                                                        <div key={doc.id}>
                                                            <select
                                                                value={
                                                                    this.state.selectedSupervisorId ||
                                                                    // Find the supervisor that matches doc.therapist's full name
                                                                    this.state.dropdownOptions[doc.id] && this.state.dropdownOptions[doc.id].find(
                                                                        supervisor => supervisor.THNO === doc.thnosupv
                                                                    )?.THNO
                                                                    || ''

                                                                }
                                                                onChange={(event) => this.handleChange(doc.id, event)}>
                                                                <option value="">--Choose an option--</option>
                                                                {Array.isArray(this.state.dropdownOptions[doc.id]) &&
                                                                    this.state.dropdownOptions[doc.id].map((supervisor, i) => (
                                                                        <option key={i} value={supervisor.THNO}>
                                                                            {`${supervisor.THFNAME} ${supervisor.THLNAME}`}
                                                                        </option>
                                                                    ))}
                                                                {!Array.isArray(this.state.dropdownOptions[doc.id]) && (
                                                                    <option disabled>No supervisors available</option>
                                                                )}
                                                            </select>
                                                            <span className={styles.button}>
                                                                <SaveButton onClick={() => this.updateSupervisor(doc.id, doc.epno)} />
                                                            </span>
                                                            <span className={styles.button}>
                                                                <CancelButton onClick={() => this.hideSupervisors(doc.id)} />
                                                            </span>
                                                        </div>)}

                                                </span>
                                            </div>
                                        }

                                        {doc.status !== 1 && doc.status !== 5 && (doc.noteType === 1 || doc.noteType === 3 || doc.noteType === 4 || doc.noteType === 5 || doc.noteType === 6) && this.props.POCSplitEnabled &&
                                            (<>
                                                {!this.props.isWp && <PatientHomeCdvPocDoc key={doc.id + "_1"} id={doc.id} />}
                                                {/* {(this.props.limberActive) ? this.props.limberLoading ? (<FontAwesomeIcon icon={faSpinner} pulse />) : <PatientHomeCdvPocLimberDoc key={doc.id + "_1_limber"} id={doc.id} limberAssessments={this.props.limberAssessments} /> : ""} */}
                                            </>)
                                        }
                                    </div>
                                )
                            })
                        }

                    </div >
                );
            }
        } else {
            return (
                <div></div>
            );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadLimber: bindActionCreators(patientActions.loadLimberAssessments, dispatch),
        loadSupervisiors: bindActionCreators(patientActions.loadSupervisiors, dispatch),
        updateSupervisior: bindActionCreators(patientActions.updateSupervisior, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let POCSplitEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_SEPARATE_POC_ENABLED'].PRVALUE === 'true' : false;
    let supervisorOptions = state.ui.cdvOptions;
    let limberActive = state.entities.admissions[ownprops.id]?.limberActive;

    let limberAssessments = Object.keys(state.entities.limberAssessments)
        .filter(key => state.entities.limberAssessments[key].epno === ownprops.id)
        .map(key => state.entities.limberAssessments[key]);

    let isWp = state.entities.admissions[ownprops.id].isWP;
    let limberLoading = state.entities.admissions?.loading;
    let epno = ownprops.id;
    let docs = Object.keys(state.entities.cdv)
        .filter(key => {
            if (state.entities.cdv[key].epno === ownprops.id) {
                if ((state.entities.masterData.PTMASTERNOTETYPES[state.entities.cdv[key].noteType].MTSONO === 1
                    || state.entities.masterData.PTMASTERNOTETYPES[state.entities.cdv[key].noteType].MTSONO === 2)
                    && state.ui.cdvOptions[state.ui.patients.selectedPtno].clinicalDocsVisible) {
                    return true;
                } else if (state.entities.masterData.PTMASTERNOTETYPES[state.entities.cdv[key].noteType].MTSONO === 3
                    && state.ui.cdvOptions[state.ui.patients.selectedPtno].fotoDocsVisible) {
                    return true;
                }
            }
            return false;
        })
        .sort((a, b) => new Date(state.entities.cdv[b].dos).getTime() - new Date(state.entities.cdv[a].dos).getTime())
        .map(key => state.entities.cdv[key]);

    return {
        supervisorOptions,
        ptno: state.ui.patients.selectedPtno,
        visible: state.ui.cdv[ownprops.id].visible,
        therapistRefreshing: state.ui.cdv[ownprops.id].therapistRefreshing,
        docs,
        POCSplitEnabled,
        limberAssessments,
        limberActive,
        limberLoading,
        isWp,
        epno,
        fotoVisible: state.ui.cdvOptions[state.ui.patients.selectedPtno].fotoDocsVisible,
    };
}



const connectedPatientHomeCdvBody = connect(mapStateToProps, mapDispatchToProps)(PatientHomeCdvBody);
export { connectedPatientHomeCdvBody as PatientHomeCdvBody };

